import React, { useContext, useEffect, useState } from 'react'
import Header from '../Header/Header'
import { Avatar, Box, Button, Container, Grid, Typography } from '@mui/material'
import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";
import XlsIcon from "../Images/xls-icon.svg"
import PdfIcon from "../Images/pdf-icon.svg"
import { AuthContext } from '../../context/AuthContext';
import { CommonContext } from '../../context/CommonContext';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { authHttp } from '../../services/commonHttpService';
import { apisPath } from '../../utils/path';
import { downloadBlob } from '../../helpers/commonHelper';

const DownloadReport = () => {
    const { userRole, facilityId, userStateId } = useContext(AuthContext);
    const { setIsLoading, setSnackState } = useContext(CommonContext);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [reportCounts, setReportCounts] = useState({
        tccc_beneficiary_count: 0,
        referred_to_dccc: 0
    });

    const roleCards = {
        4: [
            {
                title: "TCCC Beneficiary count",
                apiKey: "tccc_beneficiary_count",
                icon: <BusinessIcon sx={{ color: "#6D9BFF" }} />,
            },
            {
                title: "Referred to DCCC",
                apiKey: "referred_to_dccc",
                icon: <ApartmentIcon sx={{ color: "#6D9BFF" }} />,
            },
        ],
        5: [
            {
                title: "DCCC Beneficiary count",
                apiKey: "tccc_beneficiary_count",
                icon: <ApartmentIcon sx={{ color: "#6D9BFF" }} />,
            },
            {
                title: "Received from TCCC",
                apiKey: "referred_to_dccc",
                icon: <BusinessIcon sx={{ color: "#6D9BFF" }} />,
            },
        ],
    };

    const fetchReportCounts = async () => {
        if (!facilityId) return;
        try {
            // setIsLoading(true);
            const response = await authHttp.get(`${apisPath?.reports?.getReportDataCount}?mi_facility_id=${facilityId}`);
            if (response.data?.status) {
                setReportCounts(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching report counts:", error);
        } finally {
            // setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchReportCounts();
    }, [facilityId]);

    const handleDownload = async (format) => {
        try {
            setIsLoading(true);
            const facilityType = userRole === 5 ? "DCCC" : "MI";

            let url = `${apisPath?.reports?.reportsMaster}?facility_type=${facilityType}&state_lgd=${userStateId}&type=${format}`;

            if (fromDate) {
                url += `&from_date=${fromDate.format("YYYY-MM-DD")}`;
            }
            if (toDate) {
                url += `&to_date=${toDate.format("YYYY-MM-DD")}`;
            }

            const response = await authHttp.get(url, {
                responseType: 'blob'
            });

            const fileName = `Report_${facilityType}_${dayjs().format("YYYYMMDD")}.${format === 'excel' ? 'xlsx' : 'pdf'}`;
            downloadBlob(response.data, fileName);

        } catch (error) {
            // console.error("Download Error:", error);
            setSnackState({
                open: true,
                message: error?.response?.data?.message || error?.message || "Failed to download report",
                severity: "error",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Header showFullHeader={false} />
            <Container className="custom-container">
                <h5 className="mb-4 margin-top">Download Reports</h5>

                <Box
                    sx={{
                        background: "#fff",
                        padding: "20px",
                        borderRadius: "20px",
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                        border: "1.5px solid #E5E7EB",
                    }}
                >
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            borderBottom: "1px solid #E5E7EB",
                            paddingBottom: "20px",
                            alignItems: "center",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Grid
                            size={{ sm: 12, md: 2 }}
                        >
                            <p
                                className='text-end mb-0'
                            >
                                Search by:
                            </p>
                        </Grid>
                        <Grid
                            size={{ sm: 12, md: 2 }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    views={["year", "month", "day"]}
                                    label="From Date"
                                    format="DD-MM-YYYY"
                                    value={fromDate}
                                    onChange={(newValue) => setFromDate(newValue)}
                                    slotProps={{
                                        textField: {
                                            // variant: "standard",    // <-- underline only
                                            fullWidth: true,
                                            autoComplete: "off",
                                            onDrop: (e) => {
                                                e.preventDefault();
                                                return false;
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid
                            size={{ sm: 12, md: 2 }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    views={["year", "month", "day"]}
                                    label="To Date"
                                    format="DD-MM-YYYY"
                                    value={toDate}
                                    onChange={(newValue) => setToDate(newValue)}
                                    slotProps={{
                                        textField: {
                                            // variant: "standard",    // <-- underline only
                                            fullWidth: true,
                                            autoComplete: "off",
                                            onDrop: (e) => {
                                                e.preventDefault();
                                                return false;
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    {/* cards */}
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            marginTop: "20px"
                        }}
                    >
                        {(roleCards[userRole] || []).map((card, index) => (
                            <Grid key={index} size={{ sm: 12, md: 4 }}>
                                <Box
                                    className="downloadCard"
                                    sx={{
                                        backgroundColor: "#fff",
                                        p: 3,
                                        borderRadius: "20px",
                                        boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                                        border: "1.5px solid #E5E7EB",
                                    }}
                                >
                                    <Box display="flex" justifyContent="space-between">
                                        <Box>
                                            <Typography variant="body2" color="gray">
                                                {card.title}
                                            </Typography>
                                            <Typography variant="h5" fontWeight={600} mt={1}>
                                                {reportCounts[card.apiKey] || 0}
                                            </Typography>
                                        </Box>

                                        <Avatar
                                            sx={{
                                                bgcolor: "#E0E7FF",
                                                width: 60,
                                                height: 60,
                                                borderRadius: "15px",
                                            }}
                                        >
                                            {card.icon}
                                        </Avatar>
                                    </Box>

                                    <Box mt={3} display="flex" gap={2}>
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            className='dwnReportBtn'
                                            onClick={() => handleDownload('excel')}
                                        >
                                            <img src={XlsIcon} alt="Excel Icon" style={{ marginRight: '8px' }} />
                                            Download
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            className='dwnReportBtn'
                                            onClick={() => handleDownload('pdf')}
                                        >
                                            <img src={PdfIcon} alt="PDF Icon" style={{ marginRight: '8px' }} />
                                            Download
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}

                    </Grid>
                </Box>
            </Container>
        </>
    )
}

export default DownloadReport